import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-map-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.css']
})
export class LegendComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
